<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height">
    <use :href="href" />
  </svg>
</template>
<script>
import { defineComponent } from 'vue';
import { join } from '../common/path-general';

export default defineComponent({
  inject: ['root'],
  props: {
    width: { type: String, default: undefined },
    height: { type: String, required: true },
    src: { type: String, required: true },
    viewBox: { type: String, default: null },
  },
  computed: {
    href() {
      const isInline = this.root.vue_isSpriteExtracted === false;

      if (isInline) {
        return `#${this.src.split('#')[1]}`;
      }
      return join(this.$publicPath, 'assets/sprites', this.src);
    },
  },
});
</script>
